// import React from "react";

function Faqs() {
  return (
    <div className="max-w-3xl mx-auto py-16 px-8">
      <h1 className="h2 mb-4">FAQs</h1>
      <p className="text-lg">Frequently asked questions coming soon.</p>
    </div>
  );
}
export default Faqs;
